import * as React from 'react';
import { observer } from 'mobx-react';
import './confirmationModal.scss';

export interface IConfirmationModalProps {
    cancelMessage?: string;
    className?: string;
    confirmMessage?: string;
    isProcessing?: boolean;
    isProcessingText?: string;
    message: React.ReactNode;
    onCancel: () => void;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    isCancelLink?: boolean;
    hideAttentionIcon?: boolean;
}

@observer
export default class ConfirmationModal extends React.Component<IConfirmationModalProps> {
    constructor(props: IConfirmationModalProps) {
        super(props);
        this.handleClickCancel = this.handleClickCancel.bind(this);
        this.handleClickClose = this.handleClickClose.bind(this);
        this.handleClickConfirm = this.handleClickConfirm.bind(this);
    }

    render(): React.ReactNode {
        const { title, message, hideAttentionIcon } = this.props;
        const className = this.props.className || '';

        return (
            <div className={`pxl-modal confirmation-modal ${className}`}>
                <div className="pxl-modal__content">
                    <div className="confirmation-modal__header">
                        <h2 className="confirmation-modal__heading">
                            {!hideAttentionIcon && (
                                <i className="icon-reverse icon-circle">
                                    <i className="icon-attention-alt" />
                                </i>
                            )}
                            <span>{title}</span>
                        </h2>
                        <button className="confirmation-modal__close no-btn-style" onClick={this.handleClickClose}>
                            <i className="icon-cancel" />
                        </button>
                    </div>
                    <div className="confirmation-modal__body">
                        {message}
                    </div>
                    <div className="confirmation-modal__footer">
                        {this.renderCancelButton()}
                        <button
                            onClick={this.handleClickConfirm}
                            disabled={this.isDisabled()}
                            className="confirmation-modal__confirm-button pxl-btn pxl-btn--primary"
                        >
                            {this.buttonText()}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    private renderCancelButton(): React.ReactNode {
        const cancelMessage = this.props.cancelMessage || 'Cancel';
        return this.props.isCancelLink ? (
            <button className="confirmation-modal__cancel-button pxl-link" onClick={this.handleClickCancel}>
                {cancelMessage}
            </button>
        ) : (
            <button
                onClick={this.handleClickCancel}
                disabled={this.isDisabled()}
                className="confirmation-modal__cancel-button pxl-btn"
            >
                {cancelMessage}
            </button>
        );
    }

    private isDisabled(): boolean {
        return !!this.props.isProcessing;
    }

    private buttonText(): string {
        const { isProcessing, isProcessingText, confirmMessage } = this.props;
        if (isProcessing) {
            return isProcessingText || 'Saving...';
        }
        return confirmMessage || 'OK';
    }

    private handleClickCancel(): void {
        this.props.onCancel();
    }

    private handleClickClose(): void {
        this.props.onClose();
    }

    private handleClickConfirm(): void {
        this.props.onConfirm();
    }
}